import React from 'react'
import './styles/About.css'
import Credits from './Credits'

class About extends React.Component{

    render(){
        const {content} = this.props

        const mappedSpalte1 = content.about.filter((a)=>{ return a.inSpalte === "1" }).map((a,i)=>{
        	if( a.type === 'portrait' ){
        		return (<Portrait key={a.slug} {...a} />);
        	}else{
        		return (<Text key={a.slug} {...a} />);
        	}
        });
        const mappedSpalte2 = content.about.filter((a)=>{ return a.inSpalte === "2" }).map((a,i)=>{
        	if( a.type === 'portrait' ){
        		return (<Portrait key={a.slug} {...a} />);
        	}else{
        		return (<Text key={a.slug} {...a} />);
        	}
        });
        const mappedSpalte3 = content.about.filter((a)=>{ return a.inSpalte === "3" }).map((a,i)=>{
        	if( a.type === 'portrait' ){
        		return (<Portrait key={a.slug} {...a} />);
        	}else{
        		return (<Text key={a.slug} {...a} />);
        	}
        });

        return(
            <main className="About main">
                <div className="row">
                    <div className="col">
                        <div className="padding-bottom padding-top small-type">
                        <strong>Julian Salinas</strong>, lebt und arbeitet in Basel und Zürich 
                        </div>
                    </div>
                </div>

                <div className="row responsive">
                    <div className="col col-3">
                        { mappedSpalte1 }
                    </div>
                    <div className="col col-3">
                        { mappedSpalte2 }
                    </div>
                    <div className="col col-6">
                        { mappedSpalte3 }
                    </div>
                </div>
                <Credits />
            </main>
        )
    }


}

export default About


const Text = ({title,text,slug}) => (
  <div className='Entry' key={slug} >
    <h1 className="border-top">{title}</h1>
    <div 
        className="small-type" 
        dangerouslySetInnerHTML={{__html: text}}
    />
  </div>
);

const Portrait = ({title,url,slug}) => (
  <div className='Entry' key={slug} >
      <div className="Portrait">
      	<img src={url} alt="Portrait of Julian Salinas" />
      </div>
  </div>
);


// WEBPACK FOOTER //
// ./src/About.js